var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 318,
    height: 26,
    viewBox: "0 0 318 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34_1335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 11.6874C0 6.52354 4.18614 2.3374 9.35 2.3374H308.55C313.714 2.3374 317.9 6.52354 317.9 11.6874C317.9 16.8513 313.714 21.0374 308.55 21.0374H9.34999C4.18613 21.0374 0 16.8513 0 11.6874Z",
    fill: "#E8E4DC"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24.5438,
    height: 18.7,
    transform: "translate(0 2.3374)",
    fill: "#2A2A2A"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_34_1335)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_34_1335",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.96 11.6874C14.96 6.52354 19.1461 2.3374 24.31 2.3374C29.4738 2.3374 33.66 6.52354 33.66 11.6874C33.66 16.8513 29.4738 21.0374 24.31 21.0374C19.1461 21.0374 14.96 16.8513 14.96 11.6874Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.96 11.6874C14.96 6.52354 19.1461 2.3374 24.31 2.3374C29.4738 2.3374 33.66 6.52354 33.66 11.6874C33.66 16.8513 29.4738 21.0374 24.31 21.0374C19.1461 21.0374 14.96 16.8513 14.96 11.6874Z",
    fill: "#FAFAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.96 11.6874M33.66 11.6874M33.66 11.6874M14.96 11.6874M24.31 2.3374M33.66 11.6874M24.31 21.0374M14.96 11.6874M24.31 21.0374V20.1024C19.6625 20.1024 15.895 16.3349 15.895 11.6874H14.96H14.025C14.025 17.3677 18.6297 21.9724 24.31 21.9724V21.0374ZM33.66 11.6874H32.725C32.725 16.3349 28.9574 20.1024 24.31 20.1024V21.0374V21.9724C29.9902 21.9724 34.595 17.3677 34.595 11.6874H33.66ZM24.31 2.3374V3.2724C28.9574 3.2724 32.725 7.03993 32.725 11.6874H33.66H34.595C34.595 6.00715 29.9902 1.4024 24.31 1.4024V2.3374ZM24.31 2.3374V1.4024C18.6297 1.4024 14.025 6.00715 14.025 11.6874H14.96H15.895C15.895 7.03993 19.6625 3.2724 24.31 3.2724V2.3374Z",
    fill: "#2A2A2A",
    mask: "url(#path-2-inside-1_34_1335)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_34_1335",
    x: 11.4537,
    y: -0.0000977516,
    width: 25.7125,
    height: 25.7125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.16875,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_34_1335"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.16875
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.16875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_34_1335"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.16875
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.75313
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_34_1335",
    result: "effect2_dropShadow_34_1335"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_34_1335",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34_1335"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 11.6874C0 6.52354 4.18614 2.3374 9.35 2.3374H308.55C313.714 2.3374 317.9 6.52354 317.9 11.6874C317.9 16.8513 313.714 21.0374 308.55 21.0374H9.34999C4.18613 21.0374 0 16.8513 0 11.6874Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRange);
export default __webpack_public_path__ + "static/media/range.6249ea43e002b6e14c5cf65582c7b5b0.svg";
export { ForwardRef as ReactComponent };